
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aIhWb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $jhwJP = parcelRequire("jhwJP");


var $gzdZN = parcelRequire("gzdZN");


var $luf2A = parcelRequire("luf2A");

const $c85916255eaa04b0$var$i18nBase = (0, $h82at.defineMessages)({
    labelAlreadyAddedMessage: {
        id: "labels.labels-select.create-new-label-already-added",
        defaultMessage: "{inputValue} was already added to the page"
    },
    labelSearchErrorMessage: {
        id: "labels.labels-select.labels-search-error",
        defaultMessage: "Suggestions aren\u2019t loading. Try writing it again or refresh."
    }
});
const $c85916255eaa04b0$var$i18nLiveDocs = (0, $h82at.defineMessages)({
    labelAlreadyAddedMessage: {
        id: "labels.labels-select.create-new-label-already-added.livedocs",
        defaultMessage: "{inputValue} was already added "
    }
});
const $c85916255eaa04b0$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($c85916255eaa04b0$var$i18nBase, $c85916255eaa04b0$var$i18nLiveDocs);
const $c85916255eaa04b0$export$4b60771fa800255a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ contentId: contentId, source: source, experienceName: experienceName, components: components, styles: styles, spaceKey: spaceKey, isInDialog: //@ts-ignore react-select types
isInDialog, onUpdateSuccess: onUpdateSuccess, onAdded: //@ts-ignore react-select types
onAdded, ...customProps }, ref)=>{
    const { isDisabled: isDisabled, labelsQueryLoading: labelsQueryLoading, labelsQueryError: labelsQueryError, labelsMutationError: labelsMutationError, labelsSearchQueryError: labelsSearchQueryError, validationError: validationError, fetchRecommendedLabels: fetchRecommendedLabels, ...controlledProps } = (0, $gzdZN.useLabelsSelectProps)({
        contentId: contentId,
        source: source,
        onUpdateSuccess: onUpdateSuccess,
        onAdded: onAdded
    });
    const intl = (0, $1cfRh.default)();
    const getNoOptionsMessage = (inputValue)=>{
        if (!inputValue || (0, $gzdZN.isStarredLabel)(inputValue) || validationError) return null;
        if (labelsSearchQueryError) return intl.formatMessage($c85916255eaa04b0$var$i18n.labelSearchErrorMessage);
        return intl.formatMessage($c85916255eaa04b0$var$i18n.labelAlreadyAddedMessage, {
            inputValue: inputValue
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $luf2A.LabelsSelectComponent), {
        isDisabled: isDisabled,
        labelsQueryLoading: labelsQueryLoading,
        labelsQueryError: labelsQueryError,
        labelsMutationError: labelsMutationError,
        validationError: validationError,
        fetchRecommendedLabels: fetchRecommendedLabels,
        experienceName: experienceName,
        isInDialog: isInDialog,
        ref: ref,
        spaceKey: spaceKey,
        source: source,
        styles: styles,
        customProps: customProps,
        controlledProps: controlledProps,
        components: components,
        getNoOptionsMessage: getNoOptionsMessage
    });
});
module.exports["LabelsSelect"] = $c85916255eaa04b0$export$4b60771fa800255a;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("gzdZN", function(module, exports) {
/**
 * @generated SignedSource<<aff214c11b8d194da3579cae98eb7477>>
 * @relayHash f37b4597cc91565be901f611ccfbdd1a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dccb68f3436f199d9cc56f74f8faf3dbbc32bc642a759b50d28f525e02184293
const $5d383b914beff3cf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "entityId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "entityType",
                    "value": "page"
                },
                {
                    "kind": "Variable",
                    "name": "spaceId",
                    "variableName": "spaceId"
                }
            ],
            "concreteType": "RecommendedLabels",
            "kind": "LinkedField",
            "name": "getRecommendedLabels",
            "plural": false,
            "selections": [
                {
                    "concreteType": "RecommendedLabelItem",
                    "kind": "LinkedField",
                    "name": "recommendedLabels",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "namespace"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "strategy"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useLabelsSelectPropsRecommendedLabelsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useLabelsSelectPropsRecommendedLabelsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f37b4597cc91565be901f611ccfbdd1a",
            "id": "dccb68f3436f199d9cc56f74f8faf3dbbc32bc642a759b50d28f525e02184293",
            "metadata": {},
            "name": "useLabelsSelectPropsRecommendedLabelsQuery",
            "operationKind": "query",
            "text": "query useLabelsSelectPropsRecommendedLabelsQuery($contentId:ID!,$spaceId:ID!){getRecommendedLabels(entityId:$contentId,entityType:\"page\",spaceId:$spaceId){recommendedLabels{id,name,namespace,strategy}}}"
        }
    };
}();
$5d383b914beff3cf$var$node.hash = "a2fc96b70df294c160410b79118346b9";
var $5d383b914beff3cf$export$2e2bcd8739ae039 = $5d383b914beff3cf$var$node;


/**
 * @generated SignedSource<<b4c370c82a6acc056dbe7c7aaba61e87>>
 * @relayHash 16dda89a8ff214b88ce294908d978fb4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 998a008a7fee1762972b118a7f82c5dc3a050ee23863ab74af199df44c0fb4e8
const $34b629f4519b951a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchText"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "prefix"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "label"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "searchText",
                    "variableName": "searchText"
                }
            ],
            "concreteType": "LabelSearchResults",
            "kind": "LinkedField",
            "name": "contentLabelSearch",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Label",
                    "kind": "LinkedField",
                    "name": "suggestedLabels",
                    "plural": true,
                    "selections": v1 /*: any*/ 
                },
                {
                    "concreteType": "Label",
                    "kind": "LinkedField",
                    "name": "otherLabels",
                    "plural": true,
                    "selections": v1 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useLabelsSelectPropsLabelSearchQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useLabelsSelectPropsLabelSearchQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "16dda89a8ff214b88ce294908d978fb4",
            "id": "998a008a7fee1762972b118a7f82c5dc3a050ee23863ab74af199df44c0fb4e8",
            "metadata": {},
            "name": "useLabelsSelectPropsLabelSearchQuery",
            "operationKind": "query",
            "text": "query useLabelsSelectPropsLabelSearchQuery($contentId:ID!,$searchText:String!){contentLabelSearch(contentId:$contentId,searchText:$searchText){suggestedLabels{prefix,name,id,label},otherLabels{prefix,name,id,label}}}"
        }
    };
}();
$34b629f4519b951a$var$node.hash = "c4b7037cf05dc5bb933ddd918075cdc8";
var $34b629f4519b951a$export$2e2bcd8739ae039 = $34b629f4519b951a$var$node;


/**
 * @generated SignedSource<<4bc195df7ddb3768601f6f802e47aa9c>>
 * @relayHash 25b8cff1806cf3e404078112e461d347
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3af4a663fc421445f64d17edbd745c72fa74edb1f52c0e15cbe1810e01a9f1d8
const $c96933a500a564f4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "label"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "label",
                            "variableName": "label"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "DeleteLabelPayload",
            "kind": "LinkedField",
            "name": "deleteLabel",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "label"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useLabelsSelectPropsDeleteLabelMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useLabelsSelectPropsDeleteLabelMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "25b8cff1806cf3e404078112e461d347",
            "id": "3af4a663fc421445f64d17edbd745c72fa74edb1f52c0e15cbe1810e01a9f1d8",
            "metadata": {},
            "name": "useLabelsSelectPropsDeleteLabelMutation",
            "operationKind": "mutation",
            "text": "mutation useLabelsSelectPropsDeleteLabelMutation($contentId:ID!,$label:String!){deleteLabel(input:{contentId:$contentId,label:$label}){contentId,label}}"
        }
    };
}();
$c96933a500a564f4$var$node.hash = "8abc9b6dbe557f1c15195bda640c444e";
var $c96933a500a564f4$export$2e2bcd8739ae039 = $c96933a500a564f4$var$node;


/**
 * @generated SignedSource<<50d2896bbd07931ec942becc72864de1>>
 * @relayHash a2d3f14c75bff45a93389f308989352d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 30f67e67f8759c6613467d94fc91512ebded25adce73f03c80e1e6fb4fc5a288
const $e9614e01ad7a2cef$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "labels"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "labels",
                            "variableName": "labels"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "AddLabelsPayload",
            "kind": "LinkedField",
            "name": "addLabels",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "count"
                        },
                        {
                            "concreteType": "Label",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "prefix"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "label"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useLabelsSelectPropsAddLabelsMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useLabelsSelectPropsAddLabelsMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "a2d3f14c75bff45a93389f308989352d",
            "id": "30f67e67f8759c6613467d94fc91512ebded25adce73f03c80e1e6fb4fc5a288",
            "metadata": {},
            "name": "useLabelsSelectPropsAddLabelsMutation",
            "operationKind": "mutation",
            "text": "mutation useLabelsSelectPropsAddLabelsMutation($contentId:ID!,$labels:[LabelInput!]!){addLabels(input:{contentId:$contentId,labels:$labels}){__typename,labels{__typename,count,nodes{__typename,id,prefix,name,label}}}}"
        }
    };
}();
$e9614e01ad7a2cef$var$node.hash = "9e62a6e0f0854070c5914a70ce929b1c";
var $e9614e01ad7a2cef$export$2e2bcd8739ae039 = $e9614e01ad7a2cef$var$node;


/**
 * @generated SignedSource<<ad581e656123b1f21ce24f62ef3e0f61>>
 * @relayHash 177e078b14a8fc5099a49488fa5b9307
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d8bf72c450e072a22595a404fab60f628cddb96aafcffc4a1c819473dec459b1
const $a55e3dc265ae7696$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "orderBy",
                                    "value": {
                                        "direction": "ASCENDING",
                                        "sortField": "LABELLING_CREATIONDATE"
                                    }
                                }
                            ],
                            "concreteType": "PaginatedLabelList",
                            "kind": "LinkedField",
                            "name": "labels",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                },
                                {
                                    "concreteType": "Label",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "label"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "prefix"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useLabelsSelectPropsSSRLabelsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useLabelsSelectPropsSSRLabelsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "177e078b14a8fc5099a49488fa5b9307",
            "id": "d8bf72c450e072a22595a404fab60f628cddb96aafcffc4a1c819473dec459b1",
            "metadata": {},
            "name": "useLabelsSelectPropsSSRLabelsQuery",
            "operationKind": "query",
            "text": "query useLabelsSelectPropsSSRLabelsQuery($contentId:ID!){content(id:$contentId){nodes{id,type,status,operations{operation,targetType},space{id},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{__typename,id,label,name,prefix}}}}}"
        }
    };
}();
$a55e3dc265ae7696$var$node.hash = "86d7b3b1b2e1a3451db569340ef97a6a";
var $a55e3dc265ae7696$export$2e2bcd8739ae039 = $a55e3dc265ae7696$var$node;



var $fD4xZ = parcelRequire("fD4xZ");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $kyKWe = parcelRequire("kyKWe");


var $aDQuI = parcelRequire("aDQuI");


var $jSnXV = parcelRequire("jSnXV");


var $hJzqL = parcelRequire("hJzqL");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $bQm3c = parcelRequire("bQm3c");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $3jwuS = parcelRequire("3jwuS");


var $gEtAQ = parcelRequire("gEtAQ");


var $jMyy4 = parcelRequire("jMyy4");


var $lvOsp = parcelRequire("lvOsp");


var $308Wd = parcelRequire("308Wd");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $775f2 = parcelRequire("775f2");


var $eDV4X = parcelRequire("eDV4X");

const $6f8db0f9a73f7cef$var$useLabelsSelectPropsQuery = (0, $fD4xZ.default);
const $6f8db0f9a73f7cef$var$useLabelsSelectPropsSSRLabelsQuery = (0, $a55e3dc265ae7696$export$2e2bcd8739ae039);
const $6f8db0f9a73f7cef$var$useLabelsSelectPropsAddLabelsMutation = (0, $e9614e01ad7a2cef$export$2e2bcd8739ae039);
const $6f8db0f9a73f7cef$var$useLabelsSelectPropsDeleteLabelMutation = (0, $c96933a500a564f4$export$2e2bcd8739ae039);
const $6f8db0f9a73f7cef$var$useLabelsSelectPropsLabelSearchQuery = (0, $34b629f4519b951a$export$2e2bcd8739ae039);
const $6f8db0f9a73f7cef$var$useLabelsSelectPropsRecommendedLabelsQuery = (0, $5d383b914beff3cf$export$2e2bcd8739ae039);
const $6f8db0f9a73f7cef$var$i18n = (0, $h82at.defineMessages)({
    suggestedLabels: {
        id: "labels.use-labels-select-props.suggested-labels",
        defaultMessage: "Suggested labels"
    }
});
const $6f8db0f9a73f7cef$var$getValidationError = (inputValue)=>{
    const parsedInputValue = inputValue.replace(/^my:/, '');
    if (parsedInputValue.match((0, $eDV4X.INVALID_CHARACTERS))) // list taken from monolith here: com/atlassian/confluence/labels/LabelParser.java:39
    return 'labelsValidationInvalidCharacter';
    else if (parsedInputValue.match(/^~/)) return 'labelsValidationTilde';
    if (parsedInputValue.length > 255) return 'labelsValidationLength';
    return '';
};
const $6f8db0f9a73f7cef$var$isLabelNotFoundError = (error)=>/No label found with name/.test((0, $775f2.parseErrorMessage)(error).message);
const $6f8db0f9a73f7cef$var$isContentNotFoundError = (error)=>/No content found with id/.test((0, $775f2.parseErrorMessage)(error).message);
const $6f8db0f9a73f7cef$var$isLabelDeletePermissionsError = (error)=>/Could not delete label from content with id/.test((0, $775f2.parseErrorMessage)(error).message);
const $6f8db0f9a73f7cef$var$isLabelMutationLoggedOutError = (error)=>/Current user not permitted to use Confluence/.test((0, $775f2.parseErrorMessage)(error).message);
const $6f8db0f9a73f7cef$var$isLabelSearch403Error = (error)=>/Unexpected status code 403/.test((0, $775f2.parseErrorMessage)(error).message);
const $6f8db0f9a73f7cef$export$72ac890f53ba46be = (prefix = '')=>prefix.match(/my|global|team/)?.[0];
const $6f8db0f9a73f7cef$export$bfc1bf0a5d12c626 = (label)=>label === 'my:favourite' || label === 'my:favorite';
const $6f8db0f9a73f7cef$var$filterByPrefix = (labels, prefix)=>(labels || []).filter((label)=>label?.prefix === prefix);
const $6f8db0f9a73f7cef$var$transformToPrefixedLabel = (prefix, label)=>`${prefix && prefix !== 'global' ? `${prefix}:` : ''}${label}`;
const $6f8db0f9a73f7cef$var$sanitizeInputValue = (input)=>{
    return input.toLowerCase().replace(/\s/g, '-');
};
const $6f8db0f9a73f7cef$var$getRecommendedLabelsFromData = (data)=>data?.getRecommendedLabels?.recommendedLabels;
const $6f8db0f9a73f7cef$var$makeTransformLabelToOption = (strategy)=>(label)=>{
        const prefixedLabel = $6f8db0f9a73f7cef$var$transformToPrefixedLabel(label.prefix, label.label);
        return {
            id: label.id,
            label: prefixedLabel,
            value: prefixedLabel,
            prefix: label.prefix,
            name: label.name,
            strategy: strategy
        };
    };
const $6f8db0f9a73f7cef$var$transformRecommendedLabelToOption = (label)=>{
    const prefixedLabel = $6f8db0f9a73f7cef$var$transformToPrefixedLabel(label.namespace, label.name);
    return {
        id: label.id,
        label: prefixedLabel,
        value: prefixedLabel,
        prefix: label.namespace,
        name: label.name,
        strategy: 'recommended',
        subStrategy: label.strategy
    };
};
const $6f8db0f9a73f7cef$var$transformCurrentLabelsToSelectedOptions = (currentLabels)=>{
    if (!currentLabels) return [];
    return (currentLabels?.content?.nodes?.[0]?.labels?.nodes || []).map($6f8db0f9a73f7cef$var$makeTransformLabelToOption('current')).filter(({ label: label })=>!$6f8db0f9a73f7cef$export$bfc1bf0a5d12c626(label));
};
const $6f8db0f9a73f7cef$var$useOptions = ({ searchLabelQueryResults: searchLabelQueryResults, recommendedLabelsQueryResults: recommendedLabelsQueryResults, hasInput: hasInput })=>{
    const intl = (0, $1cfRh.default)();
    return (0, $42omo.useMemo)(()=>{
        if (hasInput) {
            const otherLabelOptions = (searchLabelQueryResults?.contentLabelSearch?.otherLabels || []).map($6f8db0f9a73f7cef$var$makeTransformLabelToOption('searched_other'));
            const suggestedLabelOptions = (searchLabelQueryResults?.contentLabelSearch?.suggestedLabels || []).map($6f8db0f9a73f7cef$var$makeTransformLabelToOption('searched_suggested'));
            return [
                ...suggestedLabelOptions,
                ...otherLabelOptions
            ];
        } else {
            const recommendedLabelOptions = ($6f8db0f9a73f7cef$var$getRecommendedLabelsFromData(recommendedLabelsQueryResults) || []).map($6f8db0f9a73f7cef$var$transformRecommendedLabelToOption);
            return [
                {
                    label: intl.formatMessage($6f8db0f9a73f7cef$var$i18n.suggestedLabels),
                    options: recommendedLabelOptions
                }
            ];
        }
    }, [
        searchLabelQueryResults,
        recommendedLabelsQueryResults,
        hasInput,
        intl
    ]);
};
const $6f8db0f9a73f7cef$export$da1c2a9c6990a15a = ({ contentId: contentId, source: source, onUpdateSuccess: onUpdateSuccess, onAdded: onAdded })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const [validationError, setValidationError] = (0, $42omo.useState)('');
    const [inputValue, setInputValue] = (0, $42omo.useState)('');
    const isLabelsPreloadedFromContent = Boolean(// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    window.__SSR_RENDERED__ && ((0, $gEtAQ.isViewPage)() || (0, $gEtAQ.isBlogPage)()) || undefined);
    const { data: ssrLabelsQueryData, loading: ssrLabelsQueryLoading, error: ssrLabelsQueryError } = (0, $jMyy4.useQueryInterop)($6f8db0f9a73f7cef$var$useLabelsSelectPropsSSRLabelsQuery, {
        variables: {
            contentId: contentId
        },
        skip: !isLabelsPreloadedFromContent
    });
    const { data: labelsQueryData, loading: labelsQueryLoading, error: labelsQueryError } = (0, $jMyy4.useQueryInterop)($6f8db0f9a73f7cef$var$useLabelsSelectPropsQuery, {
        variables: {
            contentId: contentId,
            refetchQuery: false,
            status: (0, $eDV4X.ALLOWED_CONTENT_STATUSES)
        },
        skip: isLabelsPreloadedFromContent,
        fetchPolicy: 'cache-and-network'
    });
    const labelData = (0, $42omo.useMemo)(()=>{
        if (isLabelsPreloadedFromContent) {
            if (!(0, $eDV4X.ALLOWED_CONTENT_STATUSES).includes(ssrLabelsQueryData?.content?.nodes?.[0]?.status || '')) return null;
            return ssrLabelsQueryData;
        }
        return labelsQueryData;
    }, [
        ssrLabelsQueryData,
        labelsQueryData,
        isLabelsPreloadedFromContent
    ]);
    const selectedOptions = (0, $42omo.useMemo)(()=>$6f8db0f9a73f7cef$var$transformCurrentLabelsToSelectedOptions(labelData), [
        labelData
    ]);
    const type = labelData?.content?.nodes?.[0]?.type;
    const spaceId = labelData?.content?.nodes?.[0]?.space?.id || '';
    // this will be used to disable add/delete if the user doesn't have page edit permissions
    const isDisabled = !labelData?.content?.nodes?.[0]?.operations?.find((item)=>{
        return item?.operation === 'update' && item?.targetType === type;
    });
    (0, $42omo.useEffect)(()=>{
        !(labelsQueryLoading || ssrLabelsQueryLoading) && createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'labels',
                containerId: spaceId,
                containerType: 'space',
                objectId: contentId,
                objectType: type,
                source: source,
                attributes: {
                    count: {
                        global: $6f8db0f9a73f7cef$var$filterByPrefix(selectedOptions, 'global').length,
                        personal: $6f8db0f9a73f7cef$var$filterByPrefix(selectedOptions, 'my').length,
                        total: selectedOptions.length
                    },
                    ...isLivePage ? {
                        isLivePage: isLivePage
                    } : null
                }
            }
        }).fire();
    }, [
        labelsQueryLoading,
        ssrLabelsQueryLoading,
        selectedOptions,
        spaceId,
        contentId,
        type,
        source,
        createAnalyticsEvent,
        isLivePage
    ]);
    const [addLabel, { error: addError }] = (0, $308Wd.useMutationInterop)($6f8db0f9a73f7cef$var$useLabelsSelectPropsAddLabelsMutation, {
        update (_, { data: data }) {
            const _cachedData = (0, $l1uFv.readQueryInterop)({
                query: $6f8db0f9a73f7cef$var$useLabelsSelectPropsQuery,
                variables: {
                    contentId: contentId,
                    refetchQuery: false,
                    status: (0, $eDV4X.ALLOWED_CONTENT_STATUSES)
                }
            });
            const cachedData = JSON.parse(JSON.stringify(_cachedData)); // converting read-only to mutable
            if (cachedData?.content?.nodes?.[0] && data?.addLabels?.labels) {
                const newLabels = (0, (/*@__PURE__*/$parcel$interopDefault($aDQuI)))(cachedData.content.nodes[0].labels?.nodes, data.addLabels?.labels.nodes, 'id');
                cachedData.content.nodes[0].labels = {
                    count: newLabels.length,
                    nodes: newLabels,
                    // @ts-ignore
                    __typename: 'PaginatedLabelList'
                };
                (0, $fEmGS.writeQueryInterop)({
                    query: $6f8db0f9a73f7cef$var$useLabelsSelectPropsQuery,
                    variables: {
                        contentId: contentId,
                        refetchQuery: false,
                        status: (0, $eDV4X.ALLOWED_CONTENT_STATUSES)
                    },
                    data: cachedData
                });
            }
        },
        onCompleted: ()=>{
            if (onUpdateSuccess) onUpdateSuccess();
            if (onAdded) onAdded();
        }
    });
    const handleDeleteLabelUpdate = (0, $42omo.useCallback)((_, { data: data })=>{
        const cachedData = (0, $l1uFv.readQueryInterop)({
            query: $6f8db0f9a73f7cef$var$useLabelsSelectPropsQuery,
            variables: {
                contentId: contentId,
                refetchQuery: false,
                status: (0, $eDV4X.ALLOWED_CONTENT_STATUSES)
            }
        });
        if (cachedData?.content?.nodes?.[0]?.labels?.nodes && cachedData?.content?.nodes?.[0]?.labels?.count != null) {
            // TODO: label is not a unique identifier. Either prefix + label or label id should be used instead, but neither are returned by the mutation
            const filteredCachedLabels = cachedData.content.nodes[0].labels.nodes.filter((node)=>node?.label !== data?.deleteLabel?.label);
            (0, $fEmGS.writeQueryInterop)({
                query: $6f8db0f9a73f7cef$var$useLabelsSelectPropsQuery,
                variables: {
                    contentId: contentId,
                    refetchQuery: false,
                    status: (0, $eDV4X.ALLOWED_CONTENT_STATUSES)
                },
                data: {
                    content: {
                        nodes: [
                            {
                                ...cachedData.content.nodes[0],
                                labels: {
                                    nodes: filteredCachedLabels,
                                    count: filteredCachedLabels.length,
                                    // @ts-ignore
                                    __typename: 'PaginatedLabelList'
                                }
                            }
                        ],
                        __typename: 'PaginatedContentListWithChild'
                    }
                }
            });
        }
    }, [
        contentId
    ]);
    const [deleteLabel, { error: rawDeleteError }] = (0, $308Wd.useMutationInterop)($6f8db0f9a73f7cef$var$useLabelsSelectPropsDeleteLabelMutation, {
        update: handleDeleteLabelUpdate,
        onCompleted: ()=>{
            if (onUpdateSuccess) onUpdateSuccess();
        }
    });
    const deleteError = !$6f8db0f9a73f7cef$var$isLabelNotFoundError(rawDeleteError) ? rawDeleteError : undefined;
    const [searchQuery, { data: searchLabelQueryResults, loading: searchLabelQueryLoading, error: searchLabelQueryError }] = (0, $lvOsp.useLazyQueryInterop)($6f8db0f9a73f7cef$var$useLabelsSelectPropsLabelSearchQuery, {
        onCompleted: ()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.LABELS_SEARCH_LABEL_EXPERIENCE)
            });
        },
        onError: (error)=>{
            if ($6f8db0f9a73f7cef$var$isLabelSearch403Error(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                experienceTracker.abort({
                    name: (0, $irVI7.LABELS_SEARCH_LABEL_EXPERIENCE),
                    reason: 'User was logged out'
                });
            }
            experienceTracker.fail({
                error: error,
                name: (0, $irVI7.LABELS_SEARCH_LABEL_EXPERIENCE)
            });
        }
    });
    const [recommendedLabelsQuery, { data: recommendedLabelsQueryResults, loading: recommendedLabelsQueryLoading }] = (0, $lvOsp.useLazyQueryInterop)($6f8db0f9a73f7cef$var$useLabelsSelectPropsRecommendedLabelsQuery, {
        variables: {
            contentId: contentId,
            spaceId: spaceId
        },
        onCompleted: (data)=>{
            experienceTracker.succeed({
                name: (0, $irVI7.LABELS_RECOMMENDED_EXPERIENCE)
            });
            const recommendedLabels = $6f8db0f9a73f7cef$var$getRecommendedLabelsFromData(data);
            recommendedLabels && createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'shown',
                    actionSubject: 'labelRecommendations',
                    source: source,
                    containerId: spaceId,
                    containerType: 'space',
                    objectId: contentId,
                    objectType: type,
                    attributes: {
                        count: recommendedLabels?.length
                    }
                }
            }).fire();
        },
        onError: (error)=>{
            experienceTracker.fail({
                error: error,
                name: (0, $irVI7.LABELS_RECOMMENDED_EXPERIENCE)
            });
        }
    });
    const fetchRecommendedLabels = (0, $42omo.useCallback)(()=>{
        if (type === 'page' && !isDisabled) {
            experienceTracker.start({
                name: (0, $irVI7.LABELS_RECOMMENDED_EXPERIENCE)
            });
            recommendedLabelsQuery();
        }
    }, [
        type,
        experienceTracker,
        recommendedLabelsQuery,
        isDisabled
    ]);
    const recommendedLabels = $6f8db0f9a73f7cef$var$getRecommendedLabelsFromData(recommendedLabelsQueryResults);
    const options = $6f8db0f9a73f7cef$var$useOptions({
        searchLabelQueryResults: searchLabelQueryResults,
        recommendedLabelsQueryResults: recommendedLabelsQueryResults,
        hasInput: Boolean(inputValue)
    });
    const debouncedSearchQuery = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(searchQuery, 500, {
            leading: true
        }), [
        searchQuery
    ]);
    const handleInputChange = (inputValue)=>{
        const error = $6f8db0f9a73f7cef$var$getValidationError(inputValue);
        setValidationError(error);
        setInputValue($6f8db0f9a73f7cef$var$sanitizeInputValue(inputValue));
        if (Boolean(inputValue)) {
            experienceTracker.start({
                name: (0, $irVI7.LABELS_SEARCH_LABEL_EXPERIENCE)
            });
            if (!validationError) debouncedSearchQuery({
                variables: {
                    searchText: inputValue,
                    contentId: contentId
                }
            });
        } else fetchRecommendedLabels();
    };
    const filterOption = ({ value: value })=>{
        return !searchLabelQueryError && (0, $hJzqL.createFilter)({}) && !$6f8db0f9a73f7cef$export$bfc1bf0a5d12c626(value) && !$6f8db0f9a73f7cef$var$getValidationError(value);
    };
    const fireLabelChangeEvent = (0, $42omo.useCallback)(({ action: action, labels: labels })=>{
        labels.map(({ id: labelId, name: labelName, prefix: labelPrefix, strategy: strategy, subStrategy: subStrategy })=>{
            const recommendedIndex = recommendedLabels?.findIndex(({ id: id })=>id === labelId);
            let recommendedRanking;
            if (recommendedIndex >= 0) {
                recommendedRanking = recommendedIndex;
                if (strategy?.startsWith('searched')) {
                    strategy = 'recommended_searched';
                    subStrategy = recommendedLabels[recommendedIndex].strategy;
                }
            }
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: action,
                    actionSubject: 'label',
                    source: source,
                    objectType: type,
                    objectId: contentId,
                    containerType: 'space',
                    containerId: spaceId,
                    attributes: {
                        contentId: contentId,
                        labelId: labelId,
                        strategy: strategy,
                        subStrategy: subStrategy,
                        isNewLabel: strategy === 'newly_created',
                        privacySafeLabelPrefix: $6f8db0f9a73f7cef$export$72ac890f53ba46be(labelPrefix),
                        activationId: activationId,
                        recommendedCount: recommendedLabels?.length,
                        hasRecommendations: !!recommendedLabels?.length,
                        recommendedRanking: recommendedRanking,
                        ...isLivePage ? {
                            isLivePage: isLivePage
                        } : null
                    },
                    nonPrivacySafeAttributes: {
                        labelName: labelName,
                        labelPrefix: labelPrefix
                    }
                }
            }).fire();
        });
    }, [
        type,
        source,
        contentId,
        spaceId,
        createAnalyticsEvent,
        activationId,
        recommendedLabels,
        isLivePage
    ]);
    const handleSelectLabel = (0, $42omo.useCallback)(async (option)=>{
        experienceTracker.start({
            name: (0, $irVI7.LABELS_ADD_LABEL_EXPERIENCE)
        });
        try {
            setInputValue('');
            // const optimisticResponse = J
            await addLabel({
                variables: {
                    labels: [
                        {
                            name: option.name,
                            prefix: option.prefix
                        }
                    ],
                    contentId: contentId
                },
                optimisticResponse: {
                    addLabels: {
                        __typename: 'AddLabelsPayload',
                        labels: {
                            __typename: 'PaginatedLabelList',
                            count: (labelData?.content?.nodes?.[0]?.labels?.count || 0) + 1,
                            nodes: [
                                ...labelData?.content?.nodes?.[0]?.labels?.nodes || [],
                                {
                                    __typename: 'Label',
                                    id: option.id,
                                    prefix: option.prefix,
                                    name: option.name,
                                    label: option.name
                                }
                            ]
                        }
                    }
                }
            });
            experienceTracker.succeed({
                name: (0, $irVI7.LABELS_ADD_LABEL_EXPERIENCE)
            });
            fireLabelChangeEvent({
                action: 'add',
                labels: [
                    option
                ]
            });
        } catch (error) {
            experienceTracker.fail({
                error: error,
                name: (0, $irVI7.LABELS_ADD_LABEL_EXPERIENCE)
            });
        }
    }, [
        experienceTracker,
        addLabel,
        labelData,
        fireLabelChangeEvent,
        contentId
    ]);
    const handleCreateLabel = (0, $42omo.useCallback)(async (option)=>{
        experienceTracker.start({
            name: (0, $irVI7.LABELS_CREATE_LABEL_EXPERIENCE)
        });
        try {
            setInputValue('');
            const { data: data } = await addLabel({
                variables: {
                    labels: [
                        {
                            name: option.value,
                            prefix: ''
                        }
                    ],
                    contentId: contentId
                },
                optimisticResponse: {
                    addLabels: {
                        __typename: 'AddLabelsPayload',
                        labels: {
                            __typename: 'PaginatedLabelList',
                            count: (labelData?.content?.nodes?.[0]?.labels?.count || 0) + 1,
                            nodes: [
                                ...labelData?.content?.nodes?.[0]?.labels?.nodes || [],
                                {
                                    name: option.value,
                                    prefix: '',
                                    __typename: 'Label',
                                    id: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))(),
                                    label: option.value
                                }
                            ]
                        }
                    }
                }
            });
            experienceTracker.succeed({
                name: (0, $irVI7.LABELS_CREATE_LABEL_EXPERIENCE)
            });
            fireLabelChangeEvent({
                action: 'add',
                // filter out the newly added labels from the already existing - this is necessary in order to get the new label ids to send in the analytics event
                labels: (data?.addLabels?.labels?.nodes || []).map($6f8db0f9a73f7cef$var$makeTransformLabelToOption('newly_created')).filter(({ value: value })=>option.value === value)
            });
        } catch (error) {
            experienceTracker.fail({
                error: error,
                name: (0, $irVI7.LABELS_CREATE_LABEL_EXPERIENCE)
            });
        }
    }, [
        experienceTracker,
        addLabel,
        labelData,
        fireLabelChangeEvent,
        contentId
    ]);
    const handleDeleteLabel = (0, $42omo.useCallback)(async (removedValue)=>{
        const optimisticResponse = {
            deleteLabel: {
                __typename: 'DeleteLabelPayload',
                contentId: contentId,
                label: removedValue?.name
            }
        };
        if (!removedValue) return;
        experienceTracker.start({
            name: (0, $irVI7.LABELS_DELETE_LABEL_EXPERIENCE)
        });
        try {
            await deleteLabel({
                variables: {
                    label: removedValue.name,
                    contentId: contentId
                }
            });
            experienceTracker.succeed({
                name: (0, $irVI7.LABELS_DELETE_LABEL_EXPERIENCE)
            });
            fireLabelChangeEvent({
                action: 'deleted',
                labels: [
                    removedValue
                ]
            });
        } catch (error) {
            if ($6f8db0f9a73f7cef$var$isLabelNotFoundError(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                handleDeleteLabelUpdate((0, $hp2SH.getApolloClient)(), {
                    data: optimisticResponse
                });
                experienceTracker.abort({
                    name: (0, $irVI7.LABELS_DELETE_LABEL_EXPERIENCE),
                    reason: 'label already deleted'
                });
            } else if ($6f8db0f9a73f7cef$var$isContentNotFoundError(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                experienceTracker.abort({
                    name: (0, $irVI7.LABELS_DELETE_LABEL_EXPERIENCE),
                    reason: 'Content was deleted'
                });
            } else if ($6f8db0f9a73f7cef$var$isLabelDeletePermissionsError(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                experienceTracker.abort({
                    name: (0, $irVI7.LABELS_DELETE_LABEL_EXPERIENCE),
                    reason: 'Edit permissions were removed'
                });
            } else if ($6f8db0f9a73f7cef$var$isLabelMutationLoggedOutError(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                experienceTracker.abort({
                    name: (0, $irVI7.LABELS_DELETE_LABEL_EXPERIENCE),
                    reason: 'User was logged out'
                });
            } else experienceTracker.fail({
                error: error,
                name: (0, $irVI7.LABELS_DELETE_LABEL_EXPERIENCE)
            });
        }
    }, [
        experienceTracker,
        deleteLabel,
        fireLabelChangeEvent,
        contentId,
        handleDeleteLabelUpdate
    ]);
    const handleLabelChange = async (_, { action: action, option: option, removedValue: removedValue })=>{
        if (action === (0, $eDV4X.ActionTypes).SELECT_OPTION) handleSelectLabel(option);
        else if (action === (0, $eDV4X.ActionTypes).CREATE_OPTION) handleCreateLabel(option);
        else if (action === (0, $eDV4X.ActionTypes).REMOVE_VALUE || action === (0, $eDV4X.ActionTypes).POP_VALUE) handleDeleteLabel(removedValue);
    };
    const handleMenuOpen = (0, $42omo.useCallback)(()=>{
        fetchRecommendedLabels();
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'open',
                actionSubject: 'labelsSelect',
                source: source,
                containerId: spaceId,
                containerType: 'space',
                objectId: contentId,
                objectType: type
            }
        }).fire();
    }, [
        source,
        spaceId,
        contentId,
        type,
        createAnalyticsEvent,
        fetchRecommendedLabels
    ]);
    const isLoading = searchLabelQueryLoading || recommendedLabelsQueryLoading;
    return {
        options: isLoading ? [] : options,
        value: !(labelsQueryLoading || ssrLabelsQueryLoading) ? selectedOptions : [],
        filterOption: filterOption,
        onChange: handleLabelChange,
        onMenuOpen: handleMenuOpen,
        onInputChange: handleInputChange,
        inputValue: inputValue,
        isLoading: isLoading,
        isDisabled: isDisabled,
        labelsQueryLoading: labelsQueryLoading || ssrLabelsQueryLoading,
        labelsQueryError: labelsQueryError || ssrLabelsQueryError,
        labelsMutationError: addError || deleteError,
        labelsSearchQueryError: searchLabelQueryError,
        validationError: validationError,
        fetchRecommendedLabels: fetchRecommendedLabels
    };
};
module.exports["getPrivacySafePrefix"] = $6f8db0f9a73f7cef$export$72ac890f53ba46be;
module.exports["isStarredLabel"] = $6f8db0f9a73f7cef$export$bfc1bf0a5d12c626;
module.exports["useLabelsSelectProps"] = $6f8db0f9a73f7cef$export$da1c2a9c6990a15a;

});

parcelRegister("fD4xZ", function(module, exports) {
/**
 * @generated SignedSource<<00c867f9ff32a690d2d64bc6ac01ddd2>>
 * @relayHash c16bdfa077971f51c800aa53740cee17
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 90985f9063fa73aeab5db37248e435f944e233be152dae66ff279d8a899b3988
const $d6621697d90b85f7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "refetchQuery"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "condition": "refetchQuery",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "OperationCheckResult",
                                    "kind": "LinkedField",
                                    "name": "operations",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "operation"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "targetType"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "orderBy",
                                    "value": {
                                        "direction": "ASCENDING",
                                        "sortField": "LABELLING_CREATIONDATE"
                                    }
                                }
                            ],
                            "concreteType": "PaginatedLabelList",
                            "kind": "LinkedField",
                            "name": "labels",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                },
                                {
                                    "concreteType": "Label",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "label"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "prefix"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useLabelsSelectPropsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useLabelsSelectPropsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c16bdfa077971f51c800aa53740cee17",
            "id": "90985f9063fa73aeab5db37248e435f944e233be152dae66ff279d8a899b3988",
            "metadata": {},
            "name": "useLabelsSelectPropsQuery",
            "operationKind": "query",
            "text": "query useLabelsSelectPropsQuery($contentId:ID!,$refetchQuery:Boolean!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations@skip(if:$refetchQuery){operation,targetType},space{id},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{__typename,id,label,name,prefix}}}}}"
        }
    };
}();
$d6621697d90b85f7$var$node.hash = "8cab44d2cb7a98dca8bf5c892a415540";
var $d6621697d90b85f7$export$2e2bcd8739ae039 = $d6621697d90b85f7$var$node;
module.exports["default"] = $d6621697d90b85f7$export$2e2bcd8739ae039;

});

parcelRegister("aDQuI", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");


var $hWvFC = parcelRequire("hWvFC");


var $9JSQw = parcelRequire("9JSQw");


var $ghltV = parcelRequire("ghltV");


var $bVtKl = parcelRequire("bVtKl");


var $apAFY = parcelRequire("apAFY");

/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ var $7bf644369363a294$var$unionBy = $9JSQw(function(arrays) {
    var iteratee = $apAFY(arrays);
    if ($bVtKl(iteratee)) iteratee = undefined;
    return $ghltV($8jC8i(arrays, 1, $bVtKl, true), $hWvFC(iteratee, 2));
});
module.exports = $7bf644369363a294$var$unionBy;

});

parcelRegister("8jC8i", function(module, exports) {

var $hwwIB = parcelRequire("hwwIB");


var $ifqdW = parcelRequire("ifqdW");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $60ddad71e9a2305d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $ifqdW);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $60ddad71e9a2305d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hwwIB(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $60ddad71e9a2305d$var$baseFlatten;

});

parcelRegister("ifqdW", function(module, exports) {

var $agzqu = parcelRequire("agzqu");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");

/** Built-in value references. */ var $d48df83729a0e096$var$spreadableSymbol = $agzqu ? $agzqu.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $d48df83729a0e096$var$isFlattenable(value) {
    return $fZxmY(value) || $dI6Ko(value) || !!($d48df83729a0e096$var$spreadableSymbol && value && value[$d48df83729a0e096$var$spreadableSymbol]);
}
module.exports = $d48df83729a0e096$var$isFlattenable;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("gEtAQ", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$e40fec4aab490836 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.SLIDES_VIEW).name;
    return Boolean((0, $1NBp8.SLIDES_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isSlides"] = $b5832a8b6d0203e7$export$e40fec4aab490836;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("lvOsp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jxs8y = parcelRequire("jxs8y");


var $86okN = parcelRequire("86okN");

const $278c8d04dad7bc1d$export$363a8d7f501f3769 = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryInterop(query, options) {
    const $ = (0, $frIzR.c)(2);
    {
        let t0;
        if ($[0] !== query) {
            t0 = (0, $86okN.toDocumentNode)(query);
            $[0] = query;
            $[1] = t0;
        } else t0 = $[1];
        return (0, $jxs8y.useLazyQuery)(t0, options);
    }
} : function useLazyQueryInterop(query, options) {
    return (0, $jxs8y.useLazyQuery)((0, $86okN.toDocumentNode)(query), options);
};
module.exports["useLazyQueryInterop"] = $278c8d04dad7bc1d$export$363a8d7f501f3769;

});

parcelRegister("l1uFv", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $65c7b8940c778902$export$627cb922211284f(params) {
    return $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("fEmGS", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    return $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data, variables: variables } = params;
    if (!data) return;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, root, queryFields, data, variables || {});
    });
}
function $f0827a369f0dafa9$var$writeQueryFields(storeProxy, record, fields, data, variables) {
    if (!record || !data) return;
    for (const field of fields){
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const fieldData = data[linkedField.name];
            if (fieldData !== undefined) {
                if (Array.isArray(fieldData)) {
                    const linkedRecords = fieldData.map((item)=>{
                        if (item && typeof item === 'object') {
                            const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                            const existingRecord = record.getLinkedRecord(fieldKey);
                            if (existingRecord && linkedField.selections) {
                                $f0827a369f0dafa9$var$writeQueryFields(storeProxy, existingRecord, linkedField.selections, item, variables);
                                return existingRecord;
                            }
                        }
                        return null;
                    }).filter((rec)=>rec !== null);
                    if (linkedRecords.length > 0) {
                        const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                        record.setLinkedRecords(linkedRecords, fieldKey);
                    }
                } else if (fieldData && typeof fieldData === 'object') {
                    const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                    const linkedRecord = record.getLinkedRecord(fieldKey);
                    // If no linked record exists but we have data with an ID, we can try to get the existing record,
                    // or create a new record based on __typename. However, this shouldn't be a common use-case across the codebase,
                    // so we'll skip these code paths for now
                    if (linkedRecord && linkedField.selections) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, linkedRecord, linkedField.selections, fieldData, variables);
                }
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            if (data[scalarField.name] !== undefined) record.setValue(data[scalarField.name], scalarField.name);
        }
    }
}
function $f0827a369f0dafa9$var$getFieldKey(field, variables) {
    if (!field.args || field.args.length === 0) return field.name;
    // Compute storage key for fields with arguments
    const args = field.args.map((arg)=>{
        let value;
        if (arg.kind === 'Literal') value = JSON.stringify(arg.value);
        else if (arg.kind === 'Variable') value = JSON.stringify(variables[arg.variableName]);
        else // Fallback for other argument types
        value = JSON.stringify(arg.value);
        return `${arg.name}:${value}`;
    }).join(',');
    return `${field.name}(${args})`;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("775f2", function(module, exports) {

var $irL2R = parcelRequire("irL2R");

// Regular expression to parse error message key and its arguments.
// Here is exmaple of error string which is returned from server side
// Ex: "com.atlassian.confluence.core.service.NotValidException: [ValidationError [messageKey=label.contains.invalid.chars, args=[a:b, 1, 2, 3]]]"
// `(?:\w|\.)+` : is a non-capturing group - to match with message key value
// `{1}` - exactly 1 time
// `\s*` : match any white space character
const $52dd40b6282cac81$var$re = /\[messageKey=((?:\w|\.)+){1},\s*args=\[((?:.)+)?\]\]\]/;
function $52dd40b6282cac81$export$91c32f1b22d29b2d(errorMsgObject) {
    let message = '';
    let messageKey = '';
    const args = [];
    if (typeof errorMsgObject === 'object' && errorMsgObject.message) message = errorMsgObject.message;
    // try to get error key and its arguments from error message string
    if (typeof message === 'string' && message.indexOf('messageKey') >= 0) {
        if ($52dd40b6282cac81$var$re.test(message)) {
            const results = $52dd40b6282cac81$var$re.exec(message);
            // first element of array which is returned from `re.exec` is ful string of charecter matched.
            // Ex: if message="com.atlassian.confluence.core.service.NotValidException: [ValidationError [messageKey=label.contains.invalid.chars, args=[a:b, 1, 2, 3]]]"
            // results[0] = "[ValidationError [messageKey=label.contains.invalid.chars, args=[a:b, 1, 2, 3]]]"
            // Full detail: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec
            messageKey = results[1];
            // Basing on all error messages patterns, there are maximum of 2 arguments for message.
            const argArray = results[2] ? results[2].split(',') : [];
            if (argArray) {
                args[0] = (0, (/*@__PURE__*/$parcel$interopDefault($irL2R)))(argArray);
                args[1] = argArray.slice(1).join(', ');
            }
        }
    }
    return {
        message: message,
        messageKey: messageKey,
        args: args
    };
}
module.exports["parseErrorMessage"] = $52dd40b6282cac81$export$91c32f1b22d29b2d;

});

parcelRegister("eDV4X", function(module, exports) {
const $e24dc53dc88ae3e8$export$3211963609921415 = [
    'current',
    'draft'
];
const $e24dc53dc88ae3e8$export$d7a13677648fb230 = 'edit-label-dialog-heading';
var $e24dc53dc88ae3e8$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["CLEAR"] = "clear";
    ActionTypes["CREATE_OPTION"] = "create-option";
    ActionTypes["REMOVE_VALUE"] = "remove-value";
    ActionTypes["POP_VALUE"] = "pop-value";
    ActionTypes["SELECT_OPTION"] = "select-option";
    return ActionTypes;
}({});
const $e24dc53dc88ae3e8$export$cac90560d1a4fb86 = /[:;,.•?&[\]()#^*@!<>]/;
var $e24dc53dc88ae3e8$export$b9e669a853ca2f38 = /*#__PURE__*/ function(ContentTypes) {
    ContentTypes["TEMPLATE"] = "template";
    return ContentTypes;
}({});
module.exports["ALLOWED_CONTENT_STATUSES"] = $e24dc53dc88ae3e8$export$3211963609921415;
module.exports["ActionTypes"] = $e24dc53dc88ae3e8$export$1385d81a6c6bbcd4;
module.exports["INVALID_CHARACTERS"] = $e24dc53dc88ae3e8$export$cac90560d1a4fb86;
module.exports["ContentTypes"] = $e24dc53dc88ae3e8$export$b9e669a853ca2f38;

});

parcelRegister("luf2A", function(module, exports) {
/* LabelsSelectComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");

var $1cfRh = parcelRequire("1cfRh");


var $3hOY6 = parcelRequire("3hOY6");

var $eKXGE = parcelRequire("eKXGE");


var $99qsA = parcelRequire("99qsA");


var $inPa6 = parcelRequire("inPa6");


var $1s5hv = parcelRequire("1s5hv");


var $3gadb = parcelRequire("3gadb");


var $g5gZt = parcelRequire("g5gZt");


var $jmjWc = parcelRequire("jmjWc");


var $1eaCJ = parcelRequire("1eaCJ");


var $2VQ4B = parcelRequire("2VQ4B");


var $9wGTI = parcelRequire("9wGTI");


var $1NBp8 = parcelRequire("1NBp8");


var $gzdZN = parcelRequire("gzdZN");


var $kZEms = parcelRequire("kZEms");


var $PPtZc = parcelRequire("PPtZc");

const { ValueContainer: $3a3862cb50524dec$var$ValueContainer, Input: $3a3862cb50524dec$var$Input, Control: $3a3862cb50524dec$var$Control, MultiValueContainer: $3a3862cb50524dec$var$MultiValueContainer, MultiValueLabel: $3a3862cb50524dec$var$MultiValueLabel, Option: $3a3862cb50524dec$var$Option } = (0, $3hOY6.components);

const $3a3862cb50524dec$var$LabelsQueryErrorDisplayLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "AB1Sd",
    name: "LabelsQueryErrorDisplayLoader",
    loader: async ()=>(await (parcelRequire("2z0C2"))).LabelsQueryErrorDisplay
});

const $3a3862cb50524dec$var$LabelsMutationErrorDisplayLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "1O21L",
    name: "LabelsMutationErrorDisplayLoader",
    loader: async ()=>(await (parcelRequire("2z0C2"))).LabelsMutationErrorDisplay
});

const $3a3862cb50524dec$var$LabelsValidationErrorLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "spJa0",
    name: "LabelsValidationErrorLoader",
    loader: async ()=>(await (parcelRequire("2z0C2"))).LabelsValidationError
});
const $3a3862cb50524dec$var$i18n = (0, $h82at.defineMessages)({
    inputPlaceholder: {
        id: "labels.labels-select.input-placeholder",
        defaultMessage: "Search or create a label"
    },
    createNewLabel: {
        id: "labels.labels-select.create-new-label",
        defaultMessage: "Create new label"
    },
    addLabelPlaceholder: {
        id: "labels.view-page-labels.placeholder",
        defaultMessage: "Add label"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a3862cb50524dec$var$LabelSelectOption = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1yt4otz2 _2rkofajl _1e0c1o8l _bfhk1vck _1d261gii",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a3862cb50524dec$var$CreateLabelContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a3862cb50524dec$var$CreateLabelText = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
});
const $3a3862cb50524dec$var$multiValueStyles = {
    root: "_18s81b66 _2rkofajl _1reo15vq _18m915vq _bfhki8nm _lcxv1wug _2lx21sbv _1tgk1r31 _6fpb1r31 _f6dyglyw _1gv6glyw _1wx1nqa1 _1nc7nqa1 _sfg61gdz _biqs1gdz _1un51rtt _1sjpi7uo _1u6l1y54 _1digkb7n _10j71gdz"
};
const $3a3862cb50524dec$var$inputStyles = {
    root: "_1heu1kw7 _5ce6azsu _5hv91h90"
};
const $3a3862cb50524dec$var$defaultStyles = {
    valueContainer: (provided)=>({
            ...provided,
            paddingLeft: "var(--ds-space-050, 4px)",
            paddingRight: "var(--ds-space-050, 4px)",
            paddingTop: "var(--ds-space-050, 4px)",
            paddingBottom: "var(--ds-space-050, 4px)",
            display: 'flex'
        }),
    group: (provided)=>({
            ...provided,
            paddingTop: '0'
        }),
    groupHeading: (provided)=>({
            ...provided,
            font: "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            marginBottom: "var(--ds-space-100, 8px)"
        }),
    multiValueLabel: (provided)=>({
            ...provided,
            font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            paddingLeft: "var(--ds-space-050, 4px)",
            paddingRight: "var(--ds-space-025, 2px)",
            maxWidth: '400px',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }),
    multiValue: (provided)=>({
            ...provided,
            margin: "var(--ds-space-050, 4px)",
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            '&:focus-within': {
                backgroundColor: "var(--ds-background-neutral-pressed, #080F214A)"
            },
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
            borderRadius: "var(--ds-radius-small, 3px)",
            '&:hover a, &:focus-within a': {
                textDecoration: 'none'
            },
            pointerEvents: 'auto',
            overflow: 'hidden',
            flexDirection: 'row-reverse',
            '.labels__multi-value__label': {
                '&:hover, &:hover span': {
                    backgroundColor: "var(--ds-background-neutral-pressed, #080F214A)"
                }
            },
            '.labels__multi-value__remove': {
                '&:hover': {
                    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
                }
            },
            'a > .labels__multi-value__label': {
                color: "var(--ds-text, #292A2E)"
            }
        }),
    option: (provided)=>({
            ...provided,
            width: 'max-content',
            minWidth: '100%'
        }),
    input: (provided)=>({
            ...provided,
            input: {
                fontFamily: 'inherit',
                '::placeholder': {
                    color: "var(--ds-text-subtle, #505258)"
                },
                width: 'auto !important' // needed after upgrading react-select to a version that no longer uses react-input-autosize
            }
        })
};
const $3a3862cb50524dec$var$getDisabledStyles = (isDisabled)=>{
    return isDisabled ? {
        control: (provided)=>({
                ...provided,
                '&:hover, &:focus, &:active, &:focus-within': {
                    borderColor: "var(--ds-border-inverse, #FFFFFF)"
                },
                '&:focus-within, :hover': {
                    borderColor: "var(--ds-border-inverse, #FFFFFF)"
                },
                cursor: 'default !important',
                borderWidth: '0px'
            }),
        multiValueLabel: (provided)=>({
                ...provided,
                paddingRight: "var(--ds-space-050, 4px)"
            })
    } : {};
};
const $3a3862cb50524dec$export$b0c082086b5fac02 = ({ children: children, ...props })=>{
    const { isFocused: isFocused } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a3862cb50524dec$var$Control, props, (0, $42omo.Children).map(children, (child)=>{
        if (child?.type === $3a3862cb50524dec$var$CustomValueContainer) return /*#__PURE__*/ (0, $42omo.cloneElement)(child, {
            isFocused: isFocused
        });
        return child;
    }));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a3862cb50524dec$var$CustomPlaceholder = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazazsu",
            __cmplp.className
        ])
    });
});
const $3a3862cb50524dec$var$AddLabelPlaceholder = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $3a3862cb50524dec$var$i18n.addLabelPlaceholder));
};
const $3a3862cb50524dec$var$CustomValueContainer = ({ children: children, isFocused: isFocused, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a3862cb50524dec$var$ValueContainer, props, (0, $42omo.Children).map(children, (child)=>{
        if (child?.type === $3a3862cb50524dec$var$CustomInput) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !isFocused && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a3862cb50524dec$var$CustomPlaceholder, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a3862cb50524dec$var$AddLabelPlaceholder, null)), /*#__PURE__*/ (0, $42omo.cloneElement)(child, {
            isFocused: isFocused
        }));
        return child;
    }));
};
const $3a3862cb50524dec$var$CustomInput = ({ isFocused: // @ts-expect-error isFocused is not provided by react-select
isFocused, ...props })=>{
    const intl = (0, $1cfRh.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a3862cb50524dec$var$Input, {
        ...props,
        xcss: $3a3862cb50524dec$var$inputStyles.root,
        placeholder: isFocused ? intl.formatMessage($3a3862cb50524dec$var$i18n.inputPlaceholder) : undefined
    });
}; // @atlaskit/select does not reexport the types we need: https://github.com/JedWatson/react-select/blob/master/packages/react-select/src/components/MultiValue.tsx#L92
const $3a3862cb50524dec$var$CustomMultiValueContainer = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a3862cb50524dec$var$MultiValueContainer, {
        ...props,
        xcss: $3a3862cb50524dec$var$multiValueStyles.root
    }, (0, $42omo.Children).toArray(children).reverse());
};
const $3a3862cb50524dec$var$CustomMultiValueLabel = ({ spaceKey: spaceKey, source: source, ...props })=>{
    let labelsHref;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'label',
                source: source,
                attributes: {
                    privacySafePrefix: (0, $gzdZN.getPrivacySafePrefix)(props.data.prefix)
                }
            }
        }).fire();
    }, [
        source,
        props.data.prefix,
        createAnalyticsEvent
    ]);
    try {
        if ((0, $9wGTI.fg)('confluence_frontend_labels_in_footer')) labelsHref = (0, $1NBp8.ADVANCED_SEARCH).toUrl({}, {
            query: {
                product: 'confluence',
                labels: props.data.value
            }
        });
        else labelsHref = `/wiki/label/${spaceKey}/${props.data.value}`;
    } catch (e) {
        // just in case, fallback to this so that we don't blow up the labels section
        labelsHref = '#';
    }
    return(// eslint-disable-next-line @atlassian/a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        onMouseDown: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: String(props.data.value).length >= 50 ? props.data.value : ''
    }, (tooltipProps)=>// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
            href: labelsHref,
            ...tooltipProps,
            onClick: handleClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a3862cb50524dec$var$MultiValueLabel, props)))));
};
const $3a3862cb50524dec$var$CustomOption = ({ children: children, ...props })=>{
    const { data: { __isNew__: __isNew__ }, value: value } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a3862cb50524dec$var$Option, props, __isNew__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a3862cb50524dec$var$CreateLabelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a3862cb50524dec$var$CreateLabelText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $3a3862cb50524dec$var$i18n.createNewLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a3862cb50524dec$var$LabelSelectOption, null, value)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a3862cb50524dec$var$LabelSelectOption, null, value));
};
const $3a3862cb50524dec$export$adeb07a62d3b4b29 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ isDisabled: isDisabled, labelsQueryLoading: labelsQueryLoading, labelsQueryError: labelsQueryError, labelsMutationError: labelsMutationError, validationError: validationError, fetchRecommendedLabels: fetchRecommendedLabels, experienceName: experienceName, isInDialog: isInDialog, spaceKey: spaceKey, source: source, styles: styles, customProps: customProps, controlledProps: controlledProps, components: components, getNoOptionsMessage: getNoOptionsMessage }, ref)=>{
    const intl = (0, $1cfRh.default)();
    if (labelsQueryError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a3862cb50524dec$var$LabelsQueryErrorDisplayLoader, {
        experienceName: experienceName,
        error: labelsQueryError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isInDialog || !labelsQueryLoading ? // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        onMouseEnter: fetchRecommendedLabels
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $99qsA.default), {
        // still allow focus on the input when user has no permission to edit labels, unless there are none
        isDisabled: isDisabled && Array.isArray(controlledProps?.value) && controlledProps?.value?.length === 0,
        components: {
            DropdownIndicator: null,
            Placeholder: ()=>null,
            Control: $3a3862cb50524dec$export$b0c082086b5fac02,
            ...!isDisabled && {
                ValueContainer: $3a3862cb50524dec$var$CustomValueContainer
            },
            Input: $3a3862cb50524dec$var$CustomInput,
            MultiValueContainer: $3a3862cb50524dec$var$CustomMultiValueContainer,
            MultiValueLabel: (props)=>//@ts-ignore react-select types
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a3862cb50524dec$var$CustomMultiValueLabel, {
                    spaceKey: spaceKey,
                    source: source,
                    ...props
                }),
            ...isDisabled && {
                MultiValueRemove: ()=>null
            },
            Option: $3a3862cb50524dec$var$CustomOption,
            ...components
        },
        ref: ref,
        noOptionsMessage: ({ inputValue: inputValue })=>getNoOptionsMessage(inputValue),
        styles: (0, $eKXGE.mergeStyles)($3a3862cb50524dec$var$defaultStyles, (0, $eKXGE.mergeStyles)($3a3862cb50524dec$var$getDisabledStyles(Boolean(isDisabled)), styles || {})),
        isClearable: false,
        openMenuOnClick: true,
        "aria-label": intl.formatMessage($3a3862cb50524dec$var$i18n.addLabelPlaceholder),
        isSearchable: !isDisabled,
        closeMenuOnSelect: false,
        defaultOptions: true,
        isMulti: true,
        classNamePrefix: "labels",
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a3862cb50524dec$var$AddLabelPlaceholder, null),
        validationState: validationError ? 'error' : 'default',
        ...controlledProps,
        ...customProps
    }), labelsMutationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a3862cb50524dec$var$LabelsMutationErrorDisplayLoader, {
        error: labelsMutationError
    }), validationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a3862cb50524dec$var$LabelsValidationErrorLoader, {
        error: validationError,
        input: controlledProps.inputValue
    }), !labelsQueryLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: experienceName
    }), source == 'viewPage' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VQ4B.PageSegmentLoadEnd), {
        metric: (0, $PPtZc.VIEW_PAGE_LABELS_METRIC)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZEms.LabelsSelectPlaceholder), null));
});
module.exports["CustomControl"] = $3a3862cb50524dec$export$b0c082086b5fac02;
module.exports["LabelsSelectComponent"] = $3a3862cb50524dec$export$adeb07a62d3b4b29;

});

parcelRegister("2VQ4B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $bhXnY = parcelRequire("bhXnY");


var $5EhNr = parcelRequire("5EhNr");

const $010b88689ec70f7f$export$a267cdf45880b07b = (props)=>{
    if ((0, $9wGTI.fg)('confluence_fe_deprecate_bm3')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5EhNr.UFOSegmentLoadEnd), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bhXnY.Bm3PageSegmentLoadEnd), props);
};
module.exports["PageSegmentLoadEnd"] = $010b88689ec70f7f$export$a267cdf45880b07b;

});

parcelRegister("bhXnY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $3kTfj = parcelRequire("3kTfj");


var $1NBp8 = parcelRequire("1NBp8");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");

const $9bfe2b6f868e7303$var$noop = ()=>{};
const $9bfe2b6f868e7303$var$Bm3PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ customData: customData = {}, metric: metric, onComplete: onComplete = $9bfe2b6f868e7303$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete })=>{
    // Use refs to avoid firing handlePageSegmentLoadMetricStop more than once despite changes to stopTime or customData
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handlePageSegmentLoadMetricStop = (0, $42omo.useCallback)(()=>{
        if (metric) {
            onComplete();
            let finalCustomData;
            if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
            else finalCustomData = customDataRef.current;
            const { route: route } = metric.getData();
            const shouldAddViewTransitionSource = route === (0, $1NBp8.VIEW_PAGE).name || route === (0, $1NBp8.VIEW_BLOG).name;
            if (shouldAddViewTransitionSource) finalCustomData.viewTransitionSource = (0, $lXYVJ.getViewTransitionSource)();
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${metric.key}`);
            metric.stop({
                customData: {
                    ...finalCustomData,
                    previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                    previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                stopTime: stopTimeRef.current
            });
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageSegmentLoadMetricStop, timing);
    return null;
}, /**
	 * Use lodash isEqual as comparator to avoid unnecessary re-renders
	 * i.e. when an object is defined directly within customData prop
	 * `<PageLoadSegmentEnd ... customData={{ data: 'example' }} />`
	 * (Export only for testing)
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $9bfe2b6f868e7303$export$b20cfab4e3fe23b6 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($9bfe2b6f868e7303$var$Bm3PageSegmentLoadEndComponent);
module.exports["Bm3PageSegmentLoadEnd"] = $9bfe2b6f868e7303$export$b20cfab4e3fe23b6;

});

parcelRegister("N1nBh", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
	 * This will perform the given action at a scheduled time after the
	 * component has painted.
	 *
	 * This is the default behavior.
	 */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
	 * This will perform the given action at the next animation frame (after the
	 * component has been painted).
	 */ ActionTiming["PAINT"] = "PAINT";
    /**
	 * This will perform the given action at the moment its render function
	 * fires.
	 *
	 * NOTE: This is called _within_ the render body, making it unpure. The
	 * component is memoized, so it will fire this only once for a given set
	 * of props. Be careful when using this, since it is unsafe.
	 */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $42omo.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $42omo.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("5EhNr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $cbc8g = parcelRequire("cbc8g");


var $kGwvc = parcelRequire("kGwvc");


var $1NBp8 = parcelRequire("1NBp8");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $2O7Qv = parcelRequire("2O7Qv");

const $e32532ca00da3b97$var$noop = ()=>{};
const $e32532ca00da3b97$var$UFOSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ customData: customData = {}, metric: metric, onComplete: onComplete = $e32532ca00da3b97$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete })=>{
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $42omo.useCallback)(()=>{
        if (metric) {
            onComplete();
            let finalCustomData;
            if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
            else finalCustomData = customDataRef.current;
            const { route: route } = metric.getData();
            const shouldAddViewTransitionSource = route === (0, $1NBp8.VIEW_PAGE).name || route === (0, $1NBp8.VIEW_BLOG).name;
            if (shouldAddViewTransitionSource) finalCustomData.viewTransitionSource = (0, $lXYVJ.getViewTransitionSource)();
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${metric.key}`);
            (0, $2O7Qv.addCustomTimingForMetric)(metric.key);
            (0, $cbc8g.addUFOCustomData)({
                ...finalCustomData,
                ...typeof stopTimeRef.current === 'number' ? {
                    stopTime: stopTimeRef.current
                } : {},
                previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            });
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $e32532ca00da3b97$export$9859c9d857077c0b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e32532ca00da3b97$var$UFOSegmentLoadEndComponent);
module.exports["UFOSegmentLoadEnd"] = $e32532ca00da3b97$export$9859c9d857077c0b;

});

parcelRegister("2O7Qv", function(module, exports) {

var $4u5NT = parcelRequire("4u5NT");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $4u5NT.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("kZEms", function(module, exports) {
/* ViewPageLabelsLoader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jmjWc = parcelRequire("jmjWc");


var $io723 = parcelRequire("io723");


var $PPtZc = parcelRequire("PPtZc");

const $ba30ab1568e9f84e$export$78128841bacb1fe0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i1ylp",
            __cmplp.className
        ])
    });
});

const $ba30ab1568e9f84e$var$ViewPageLabelsLoaderBase = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vfOAM",
    name: "ViewPageLabelsLoaderBase",
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba30ab1568e9f84e$export$78128841bacb1fe0, null),
    loader: async ()=>(await (parcelRequire("k189T"))).ViewPageLabels
});
const $ba30ab1568e9f84e$export$34eb2891dd16ab98 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
        metric: (0, $PPtZc.VIEW_PAGE_LABELS_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba30ab1568e9f84e$var$ViewPageLabelsLoaderBase, props));
module.exports["LabelsSelectPlaceholder"] = $ba30ab1568e9f84e$export$78128841bacb1fe0;
module.exports["ViewPageLabelsLoader"] = $ba30ab1568e9f84e$export$34eb2891dd16ab98;

});

parcelRegister("io723", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $1AtJA = parcelRequire("1AtJA");


var $dZzho = parcelRequire("dZzho");

const $cd95c7f874921f86$export$f11db193fdaffcc9 = (props)=>{
    if ((0, $9wGTI.fg)('confluence_fe_deprecate_bm3')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dZzho.UFOSegmentLoadStart), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1AtJA.Bm3PageSegmentLoadStart), props);
};
module.exports["PageSegmentLoadStart"] = $cd95c7f874921f86$export$f11db193fdaffcc9;

});

parcelRegister("1AtJA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3kTfj = parcelRequire("3kTfj");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");

const $2994f14f1333f67a$var$noop = ()=>{};
const $2994f14f1333f67a$var$Bm3PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, onComplete: onComplete = $2994f14f1333f67a$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY, isCustomStart: isCustomStart = false })=>{
    const handlePageLoadMetricStart = (0, $42omo.useCallback)(()=>{
        if (metric) {
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${metric.key}`);
            if (isCustomStart) metric.start();
            else metric.startFromPageLoad();
            onComplete();
        }
    }, [
        metric,
        onComplete,
        isCustomStart
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageLoadMetricStart, timing);
    return null;
});
const $2994f14f1333f67a$export$d807afe46329fe8a = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($2994f14f1333f67a$var$Bm3PageSegmentLoadStartComponent);
module.exports["Bm3PageSegmentLoadStart"] = $2994f14f1333f67a$export$d807afe46329fe8a;

});

parcelRegister("dZzho", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGwvc = parcelRequire("kGwvc");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");

const $762a25b728d4d734$var$noop = ()=>{};
const $762a25b728d4d734$var$UFOSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, onComplete: onComplete = $762a25b728d4d734$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY })=>{
    const handleSegmentLoadStart = (0, $42omo.useCallback)(()=>{
        if (metric) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${metric.key}`);
            onComplete();
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $762a25b728d4d734$export$30c533f25ae06bb = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($762a25b728d4d734$var$UFOSegmentLoadStartComponent);
module.exports["UFOSegmentLoadStart"] = $762a25b728d4d734$export$30c533f25ae06bb;

});

parcelRegister("PPtZc", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $7c335dc4c85f3f9f$export$3a36b2d62e2d34a2 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.VIEW_PAGE_LABELS_METRIC_KEY)
});
module.exports["VIEW_PAGE_LABELS_METRIC"] = $7c335dc4c85f3f9f$export$3a36b2d62e2d34a2;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;

});

parcelRegister("k189T", function(module, exports) {

let $03c2bee234ff9089$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $03c2bee234ff9089$var$load("5dBst"),
    $03c2bee234ff9089$var$load("7EorR"),
    $03c2bee234ff9089$var$load("jigcs"),
    $03c2bee234ff9089$var$load("4LmEY")
]).then(()=>parcelRequire('heHIK'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("2z0C2", function(module, exports) {

let $1ddf534dc32afbd3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1ddf534dc32afbd3$var$load("718G0").then(()=>parcelRequire('iZY6P'));

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});


//# sourceMappingURL=LabelsSelect.c3ddb9f4.js.map
